<section class="index-link">
  <div class="container">
      <div class="row footer_gap">
          <div class="col-md-8 col-lg-5 footer_section1">
              <div class="link-area">
                <div>
                  <a href="index.html"> <img src="../../../assets/images/Final_Logo-01.png" alt="footerlogo" class="footer_logo" />
                   </a>
                  <p style="color: black;width: 300px;">Take actions that make an impact. Providing services
                     for all to grow and prosper.</p>
                </div>
              </div>
          </div>
          <div class="col-md-8 col-lg-4 footer_section2">
              <div class="link-area">
                <p>
                  <i class="fa fa-envelope mr-3" style="color:#fc0e40;font-size: 15px;"></i>
                  <a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=1&source=mailto&su=Hi+There&to=connect@manteio.in&body=body+goes+here" target="_blank" style="color:black;">
                  connect@manteio.in</a>
              </p>

              <p>
                  <i class="fa fa-phone mr-3" style="color:#fc0e40;transform: rotate(0deg);font-size: 20px;"></i>
                  <a href="tel:+919391385170" style="color: black;">+91 9391385170</a>
              </p>
              <p style="color: black;">
                  <i class="fa fa-map-marker mr-3" style="color:#fc0e40;font-size: 20px;"></i>
                  <span style="color: black; margin-top: -14px;">The Platina, B-605,</span>
              </p>
              <p class="contact_address_footer">Gachibowli, Telangana 500032</p>



              </div>
          </div>
          <div class="col-md-8 col-lg-3 footer_section3">
            <div class="link-area">
                <h5 style="color: black;font-size: 18px;">Powered by</h5>
                <div class="manteiologo">
                    <a href="#" >
                    <img src="../../assets/images/manteio_b.png" alt="manteiologo" style="width: 100%;"/>
                    </a>
                </div>
                <div>
                  <a href="https://www.facebook.com/manteioIT/" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-facebook" aria-hidden="true"></i></span>
                  </a>
                  <a href="https://www.twitter.com/manteioIT" class="sicons" target="_blank">
                     <span class="icon social"><i class="fa fa-twitter"></i></span>
                  </a>
                  <a href="https://www.linkedin.com/company/manteiotechnologies" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-linkedin-square" aria-hidden="true"></i></span>
                  </a>
                  <a href="https://www.instagram.com/manteio_it_solutions" class="sicons" target="_blank">
                    <span class="icon social">  <i class="fa fa-instagram" aria-hidden="true"></i></span>
                  </a>
                </div>
            </div>
        </div>

      </div>
  </div>
</section>
<section style="background-color: #282729;padding-top:10px;padding-bottom: 10px;">
  <div class="container">
         <!-- Copyright -->
   <div class="footer-copyright">
    <div class="sectionmargin">
      <div class="row">
        <div class="col-md-4">

        </div>
        <div class="col-md-5">
          <p class="rightsreserved" style="margin-bottom: 0rem;"><a href="#" style="color: #fff;"> ©2023 Copyright - All Rights Reserved</a></p>
        </div>
        <div class="col-md-3">

        </div>
      </div>
    </div>
  </div>
  </div>
</section>
<!-- End footer Area -->


